<script>
var mqttClient = null,
  mqttClientid = "",
  topic = [];

function connentMqtt(clientid) {
  var self = this;
  if (!!!self.mqttClient) {
    self.mqttClientid = clientid.replace(/-/g, "");
    self.mqttClient = new Paho.MQTT.Client(
      "mqtt.mibee.cn",
      443,
      "/ws",
      "h5_heatpump_" + clientid
    );
  }
  try {
    self.mqttClient.connect({
      userName: "menred",
      password: "menred4855",
      reconnect: true,
      useSSL: true,
      onSuccess: function () {
        if (self.topic.length > 0) {
          self.topic.forEach((x) => {
            self.mqttClient.subscribe(x);
          });
        }
      },
      onFailure: function (e) {
        console.error("mqtt连接失败" + e);
      },
    });
  } catch (e) {
    console.log(e);
  }
}

function mqttSend(srcaddress, msg, topic, func) {
  var self = this;
  if (self.mqttClient) {
    try {
      console.log(Math.round(new Date().getTime()/1000)+"-发送信息：" + JSON.stringify(msg));
      var message = new Paho.MQTT.Message(JSON.stringify(msg));
      message.destinationName = "app/" + self.mqttClientid + "/" + srcaddress;
      if (topic) {
        message.destinationName = topic;
      }
      self.mqttClient.send(message);
    } catch (e) {
      func("mqtt未连接" + e);
    }
  } else {
    func("mqtt连接未创建");
  }
}
function mqttsubscribe(topic) {
  var self = this;
  if (self.mqttClient) {
    if (self.topic.length > 0) {
      self.topic.forEach((x) => {
        self.mqttClient.unsubscribe(x);
      });
    }
    self.topic = topic;
    topic.forEach((x) => {
      self.mqttClient.subscribe(x);
    });
  }
}
function mqttReceive(topic, func) {
  var self = this;
  if (self.mqttClient) {
    try {
      if (topic && topic.length > 0) {
        self.mqttsubscribe(topic);
      }
      self.mqttClient.onMessageArrived = func;
    } catch (e) {
      console.log(e);
      func("接受消息错误" + e);
    }
  } else {
    func("mqtt连接未创建");
  }
}

function closeMqtt() {
  if (this.mqttClient) {
    try {
      this.mqttClient.disconnect();
      this.mqttClient = null;
    } catch (e) {
      console.log(e);
    }
  }
}

function newGuid() {
  var guid = "";
  for (var i = 1; i <= 32; i++) {
    var n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
  }
  return guid;
}

export default {
  mqttClient,
  mqttClientid,
  topic,
  connentMqtt,
  mqttSend,
  mqttsubscribe,
  mqttReceive,
  closeMqtt,
  newGuid,
};
</script>


// WEBPACK FOOTER //
// src/Common.vue